const _ = require('lodash');
const { appyDealsCheck, isAppyDealsBadge, APPY_DEALS_PAGE_SOURCE_ID, APPY_DEALS_EVENT_DATA } = require('../../../../../common/utility/appyDealsCheck');
const atmAddToFavoriteMapper = require('./atm-mapper-add-to-favorite');
const atmCrossSellCartAddedMapper = require('./atm-mapper-cross-sell-cart');
const atmRemoveFromFavoriteMapper = require('./atm-mapper-remove-from-favorite');
const atmProductViewMapper = require('./atmmapper/product-view-mapper');
const atmProductCrossSellMapper = require('./atm-mapper-product-view-cross-sell');
const pdpLinkClickMapper = require('./atm-mapper-pdp-link-click');
const linkTextPipe = require('../../../../../common/filters/bws-link-text')();
const atmRelatedProductsViewMapper = require('../relatedproducts/atmmapper/related-products-view-mapper');
const formatDate = require('../../../../../common/utility/date-formatter');
const buyOnlineMapper = require('../../../trolley/atmmapper/online-buy-gs-mapper');

module.exports = function ($stateParams, detailProductService, pageMetadataService, categoriesService, $state, $uibModal, trolleyService, savedListsService, $rootScope, atm, hyphenate, $timeout, storePickerService, breakpointService, shopPageStateService, settingsService, $log, bwsNotificationService, storePickerPanelService, currentUserService, $sce, collectionTimeService, shopperService, $location, badgeService, inMemoryStorage) {
    return {
        restrict: 'E',
        replace: true,
        controllerAs: 'ctrl',
        scope: {
            showStickyHeader: '=?'
        },
        template: require('./detail-product-page-template.html').trim(),
        compile: () => {
            return {
                pre: ($scope) => {
                    $scope.badgeService = badgeService;
                    $scope.breakpointService = breakpointService;
                    $scope.productCollection = null;
                    $scope.loading = true;
                    $scope.isDetail = true;
                    $scope.isNoIndexPage = false;
                    $scope.productId = $stateParams.productId;
                    $scope.productDetails = {};
                    $scope.productBadge = null;
                    $scope.isSmallFormat = breakpointService.isSmallFormat();
                    $scope.imageZoomSize = breakpointService.isSmallFormat() ? 'md' : 'lg';
                    $scope.displayCategoryLink = false;
                    $scope.showGoogleShopping = false;
                    $scope.showGoogleShoppingDetails = {};
                    $scope.regionId = '';
                    let modalInstance = null;
                    $scope.storePicker = storePickerService;
                    $scope.additionalDetailsIsOpen = false;
                    $scope.defaultProductCode = '';
                    $scope.selectedGSStore = '';
                    $scope.ctrl = $scope.ctrl || {};
                    $scope.ctrl.showAppyDeals = false;
                    let isEnableAppBasedOffers = false;

                    $scope.goToProductPage = () => {
                        $location.path($location.path()).search({});
                    };
                    $scope.getCarousel = function (isImageZoom) {
                        if (isImageZoom) {
                            $scope.imageZoomCarousel = [];
                            const zoomImages = [];
                            angular.forEach($scope.productCollection.Products, function (product) {
                                let i = 1;
                                while (product.ProductData['image' + i]) {
                                    zoomImages.push(product.ProductData['image' + i]);
                                    i++;
                                }
                            });

                            $scope.imageZoomCarousel = zoomImages;

                        } else {
                            $scope.carousel = [];
                            const images = [];

                            let i = 1;
                            while ($scope.product.ProductData['image' + i]) {
                                images.push($scope.product.ProductData['image' + i]);
                                i++;
                            }

                            $scope.carousel = images;
                        }

                    };
                    //Validate the URL if it is browse page
                    if ($state.includes('shop.browse')) {
                        $scope.validateProductUrl = true;
                    } else {
                        $scope.validateProductUrl = false;
                    }

                    $scope.openStorePicker = function () {
                        storePickerPanelService.open();

                        $timeout(function () {
                            storePickerPanelService.changeStoreView = true;
                        }, 1000);
                    };

                    function getProductBackOrderStockOnHand() {
                        $scope.productStockOnHand = $scope.product.BackorderStockOnHand > ($scope.product.ProductData.maxpurchasequantity || $scope.product.SupplyLimit) ? ($scope.product.ProductData.maxpurchasequantity || $scope.product.SupplyLimit) : $scope.product.BackorderStockOnHand + $scope.product.StockOnHand;
                    }

                    function checkAvailability() {
                        if ($scope.product.IsAvailable && ($scope.productParent.ProductData.displayonly === undefined || !$scope.productParent.ProductData.displayonly)) {
                            if ($scope.product.StockOnHand > 0) {
                                $scope.availabilityMessage = 'Available';
                            } else {
                                $scope.availabilityMessage = 'Out of stock';
                            }
                        } else {
                            $scope.availabilityMessage = 'Unavailable';
                        }
                    }

                    function getSavingsAmount() {
                        return ($scope.product.PercentageOffTag.TagType !== 'None' || $scope.product.FixedPricePromoTag.TagType !== 'None')
                            ? ($scope.product.PercentageOffTag.SavedAmount || $scope.product.FixedPricePromoTag.SavedAmount)
                            : $scope.product.SavingsAmount;
                    }

                    function showSuperSaversBadge() {
                        return $scope.badgeService.showSuperSaversBadge($scope.product);
                    }

                    function showSavingsBadge() {
                        if (showSuperSaversBadge()) return false;
                        if ($scope.badgeService.isShelfTalkerTypeGreatValue($scope.product)) return false;
                        return (!$scope.product.HideWasSavedPrice && $scope.product.SavingsAmount > 0 && !$scope.restrictedCategory)
                            || $scope.product.PercentageOffTag.SavedAmount > 0 && $scope.product.PercentageOffTag.TagType !== 'None'
                            || $scope.product.FixedPricePromoTag.SavedAmount > 0 && $scope.product.FixedPricePromoTag.TagType !== 'None';
                    }

                    function transformAdditionalDetails() {
                        return _.forEach($scope.productParent.AdditionalDetails, function (item) {
                            $scope.productDetails[item.Name] = item.Value;
                        });
                    }

                    function analyticsRelatedProductView() {
                        //Analytics for Products in same offer view
                        if ($scope.product.ProductsInSameOffer.Items) {
                            const data = {
                                productGroupName: $scope.product.ProductsInSameOffer.Name,
                                productGroupId: $scope.product.ProductsInSameOffer.Id
                            };

                            atm.push(data, atmRelatedProductsViewMapper);
                        }
                    }

                    function stripOutJsonFormatInAddtionalDetails(details) {
                        for (let i = 0; i < details.length; i++) {
                            if (details[i].Value && details[i].Value.constructor === Array) {
                                details[i].Value = details[i].Value.join(', ');
                            }
                        }
                    }

                    function cleanAdditionalDetailsForDisplay() {
                        $scope.AdditionalDetailsDisplay = _.reject($scope.productParent.AdditionalDetails, { DisplayName: null });
                        $scope.CategoryLeafNodeNames = '';

                        stripOutJsonFormatInAddtionalDetails($scope.AdditionalDetailsDisplay);

                        const order = ['varietal', 'liquorstyle', 'beertype', 'cidertype', 'spirittype', 'whiskytype', 'subregionoforigin', 'regionoforigin', 'stateoforigin', 'countryoforigin', 'countrybottledin', 'vintage', 'age', 'award\'swon', 'ibu', 'alcohol%', 'standarddrinks', 'liquorsize', 'closuretype', 'bottleopenerrequired', 'winemaker', 'brewer', 'brewery', 'distiller', 'distillery', 'tastingnotes', 'preservativefree', 'biodynamic', 'glutenfree', 'kosher', 'foodmatching', 'brand_name', 'defaultproductsku'];
                        const results = [];

                        // loop on order
                        for (let j = 0; j < order.length; j++) {

                            // loop on product details
                            for (let i = 0; i < $scope.AdditionalDetailsDisplay.length; i++) {
                                // test if order is equal product detail name
                                if (order[j] === $scope.AdditionalDetailsDisplay[i].Name) {
                                    results.push($scope.AdditionalDetailsDisplay[i]);

                                    //Find the variety
                                    if ($scope.AdditionalDetailsDisplay[i].Name === 'varietal') {
                                        $scope.varietal = $scope.AdditionalDetailsDisplay[i].Value;
                                    }

                                    $scope.AdditionalDetailsDisplay[i].isFound = true;
                                }

                            }
                        }

                        // add all product detail not found in the order list
                        for (let i = 0; i < $scope.AdditionalDetailsDisplay.length; i++) {
                            if (!$scope.AdditionalDetailsDisplay[i].isFound) {
                                results.push($scope.AdditionalDetailsDisplay[i]);
                            }

                            //Find the category name
                            if ($scope.AdditionalDetailsDisplay[i].Name.toLowerCase() === 'categorynodename') {
                                $scope.CategoryLeafNodeNames = $scope.AdditionalDetailsDisplay[i].Value.split(',');
                            }
                        }

                        $scope.AdditionalDetailsDisplay = results;
                    }

                    function checkRestrictedCategory() {
                        try {
                            settingsService.getSettingValue('ProductRestrictions', 'CategoryIds').then((restrictedCategories) => {
                                $scope.restrictedCategory = (_.intersection(restrictedCategories, $scope.productDetails.categoryleafnodeid.map(id => id.toString())).length > 0);
                            });
                        } catch (e) {
                            $log.log('Oups, there is something wrong with the selected product data.');
                            $log.log(e);
                        }
                    }

                    function aisleIsNotPrimaryCategory(primaryCategory) {
                        return primaryCategory !== categoriesService.currentCategory.aisle.Name.toLowerCase() && $state.includes('shop.browse.category.aisle');
                    }

                    function shopperInSpecialsBrowseOrSpecialsGroup() {
                        return $state.includes('shop.specials.browse') || $state.includes('shop.specials.groups');
                    }

                    $scope.setIsNoIndexPage = function (primaryCategory) {
                        if (aisleIsNotPrimaryCategory(primaryCategory) || shopperInSpecialsBrowseOrSpecialsGroup()) {
                            $scope.isNoIndexPage = true;
                        }
                    };
                    $scope.title = 'Product Details';

                    $scope.addOrUpdateTrolley = function () {
                        if ($rootScope.isGoogleProduct) {
                            const atmData = { product: $scope.productDefault, area: 'Product' };
                            atm.push(atmData, atmCrossSellCartAddedMapper);
                            $rootScope.isGoogleProduct = false;
                        }
                        $scope.isBeingAddedToTrolley = false;
                        $scope.productCollection.IsInTrolley = true;

                        _.forEach($scope.productCollection.Products, function (product) {
                            product.IsInTrolley = false;
                        });

                        $scope.product.IsInTrolley = true;

                        $scope.productCollection.QuantityInTrolley = $scope.product.DisplayQuantity;

                        trolleyService.addOrUpdateTrolley($scope.product, 'product').then(function () {

                            const maxPurchaseQuantity = parseInt($scope.product.ProductData.maxpurchasequantity) || $scope.product.SupplyLimit;
                            const pluralizePackSize = $scope.product.StockOnHand > 1 || $scope.product.BackorderStockOnHand > 1 ? 's' : '';
                            const pluralizeNoun = $scope.product.StockOnHand > 1 || $scope.product.BackorderStockOnHand > 1 ? 'are' : 'is';

                            bwsNotificationService.clearAll();

                            if ($scope.product.DisplayQuantity > maxPurchaseQuantity) {
                                bwsNotificationService.info('Sorry, a purchase limit of ' + maxPurchaseQuantity + ' applies to this product');
                            } else if ($scope.product.DisplayQuantity > $scope.product.StockOnHand && $scope.product.BackorderStockOnHand === 0) {
                                bwsNotificationService.info(`Sorry, only ${$scope.product.StockOnHand} <span class='text-lowercase'>${$scope.product.ProductData.webpacktype}</span>${pluralizePackSize} ${pluralizeNoun} available.`);
                            }
                        });
                    };

                    $scope.initCarousel = function (initCarousel) {
                        $scope.getCarousel(initCarousel);

                        const options = {
                            method: {},
                            infinite: false,
                            speed: 300,
                            dots: true,
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            accessibility: true,
                            swipeToSlide: true,
                            lazyLoad: 'ondemand',
                            lazyLoadBuffer: 0,
                            arrows: true
                        };

                        $timeout(() => {
                            if (angular.element('.modal--image-zoom').length) {
                                $scope.slickConfigImageZoom = options;
                                $scope.slickConfigImageZoom.arrows = false;

                                const imgRef = $scope.product.ProductData.image1;

                                $scope.slickConfigImageZoom.event = {
                                    init: (event, slick) => {
                                        let slideRef;

                                        angular.forEach(slick.$slides, function (slide, i) {
                                            if (slide.dataset.imageName === imgRef) {
                                                slideRef = i;
                                            }
                                        });

                                        slick.slickGoTo(slideRef);
                                    }
                                };

                                $scope.slickConfigImageZoomLoaded = false;
                                // apply to the next digest cycle
                                $timeout(() => {
                                    $scope.slickConfigImageZoomLoaded = true;
                                    $scope.loading = false;
                                }, 10, true);
                            } else {
                                $scope.slickConfig = options;

                                $scope.slickConfigLoaded = false;
                                // apply to the next digest cycle
                                $timeout(() => {
                                    $scope.slickConfigLoaded = true;
                                    $scope.loading = false;
                                }, 10, true);
                            }
                        }, 10, true);
                    };

                    $scope.$on('productFamily:update', function (e, data) {
                        if ($scope.product.ParentStockCode === data.product.ParentStockCode) {
                            $scope.product = data.product;
                            $scope.product.DisplayQuantity = data.qty;
                            $scope.currentControlsQty = data.qty;
                            $scope.initCarousel();
                            checkAvailability();
                            $scope.savingsAmount = getSavingsAmount();
                            $scope.showSavingsBadge = showSavingsBadge();
                            $scope.showSuperSaversBadge = showSuperSaversBadge();
                            $scope.ctrl.showPercentageOffBadge = $scope.badgeService.showPercentageOffBadge($scope.product);
                            getProductBackOrderStockOnHand();
                            
                            // refresh scope.ctrl.showAppyDeals flag
                            if (isEnableAppBasedOffers) {
                                $scope.ctrl.showAppyDeals = !$scope.restrictedCategory
                                    ? appyDealsCheck($scope.product)
                                    : false;
                            }
                        }
                    });

                    $scope.$on('trolleyControls:update', function (e, quantity) {

                        if (quantity) {
                            $scope.currentControlsQty = quantity;
                        }

                    });

                    $scope.checkWithDevice = function (index) {
                        if ($('.device-xs').is(':visible')) {
                            return index <= 2;
                        } else if ($('.device-sm').is(':visible')) {
                            return index <= 1;
                        } else if ($('.device-md').is(':visible')) {
                            return index <= 2;
                        } else if ($('.device-lg').is(':visible')) {
                            return index <= 3;
                        }
                    };

                    $scope.onUpdateTrolley = function () {
                        if ($scope.product.QuantityInTrolley !== $scope.product.DisplayQuantity) {
                            $scope.isBeingAddedToTrolley = true;
                        }
                    };

                    $scope.toggleCheckStockPopup = function (analyticsType) {
                        modalInstance = $uibModal.open({
                            animation: true,
                            templateUrl: 'stock-nearby-product-detail',
                            scope: $scope,
                            size: 'lg'
                        });
                        atm.push({
                            linkName: `web:pdp:${analyticsType}`,
                            linkType: 'pdp check stock availability'
                        }, pdpLinkClickMapper);
                    };

                    $scope.handleCategoryAnalytics = function (category) {
                        atm.push({
                            linkName: `web:pdp:discover more:${linkTextPipe(category).toLowerCase()}`,
                            linkType: 'pdp discover more'
                        }, pdpLinkClickMapper);
                    };
                    $scope.whyThisStore = function () {
                        modalInstance = $uibModal.open({
                            animation: true,
                            templateUrl: 'why-this-store-modal',
                            scope: $scope,
                            size: 'lg',
                            windowClass: 'gs gs-store-modal'
                        });
                        atm.push('google shop:why this store', buyOnlineMapper);
                    };

                    $scope.closePopup = function () {
                        modalInstance.dismiss('cancel');
                    };

                    $scope.hideTooltip = function (e) {
                        $timeout(function () {
                            $(e.currentTarget).closest('.product-detail_controls').find('.tooltip').removeClass('animated fadeInDown is-active');
                        }, 5000);
                    };

                    $scope.$on('trolley:update', function (e, data) {
                        if (data.product && data.product.Stockcode === $scope.product.Stockcode && data.type === 'update') {
                            const item = trolleyService.getTrolleyItem($scope.product.Stockcode);

                            $scope.product.QuantityInTrolley = item.Quantity;
                            $scope.productCollection.QuantityInTrolley = item.Quantity;
                            $scope.productCollection.IsInTrolley = true;
                            $scope.product.IsInTrolley = true;

                        } else {
                            $scope.isBeingAddedToTrolley = true;
                            $scope.product.IsInTrolley = false;
                            $scope.productCollection.QuantityInTrolley = 0;
                            $scope.productCollection.IsInTrolley = false;
                        }

                    });

                    $rootScope.$on('cart:autoUpdate', function (e, quantity, product) {
                        if (product.ParentStockCode === $scope.product.ParentStockCode) {
                            $scope.currentControlsQty = quantity;
                        }
                    });

                    $scope.toggleWatchList = _.debounce(function (stockcode) {
                        if ($scope.productDefault.IsWatched) {
                            $scope.removeItemFromWatchList(stockcode);
                            shopperService.currentUser.numberOfItemsInWatchList--;
                        } else {
                            $scope.addToWatchList(stockcode);
                            shopperService.currentUser.numberOfItemsInWatchList++;
                        }
                    }, 200);

                    $scope.openCart = function () {
                        shopPageStateService.triggerPanel('right', true, 'product');
                    };

                    $scope.addToWatchList = function (stockcode) {
                        savedListsService.addToList(stockcode, 1, $scope.productDefault)
                            .then((response) => {
                                $scope.isWatched = true;
                                $scope.productDefault.IsWatched = true;
                                savedListsService.getList().then(() => {
                                    $rootScope.$emit('watchlist:updated');
                                });

                                const atmData = {
                                    product: $scope.productDefault,
                                    area: 'Product',
                                    headers: response.headers
                                };
                                atm.push(atmData, atmAddToFavoriteMapper);
                            }, () => {
                                $timeout(() => {
                                    if (currentUserService.currentUser.isGuest) {
                                        bwsNotificationService.info('You need to login or register to add to your favourites');
                                    }
                                }, 2000);
                            });
                    };

                    $scope.removeItemFromWatchList = function (stockcode) {
                        savedListsService.removeFromWatchList(stockcode)
                            .then(() => {
                                $scope.isWatched = false;
                                $scope.productDefault.IsWatched = false;
                                savedListsService.getList().then(() => {
                                    $rootScope.$emit('watchlist:updated');
                                });
                                const atmData = {
                                    product: $scope.productDefault,
                                    area: 'Product'
                                };
                                atm.push(atmData, atmRemoveFromFavoriteMapper);
                            });
                    };

                    $scope.hyphenate = function (value) {
                        return hyphenate(value);
                    };

                    let brandcategory, department, subdepartment, category, subcategory;

                    function viewRelatedProducts() {
                        if ($scope.productParent.ProductData.brandcategory) {

                            $scope.url = '';
                            $scope.stateObj = '';

                            if (brandcategory.length === 4) {
                                $scope.url = 'shop.browse.department.subdepartment.category.subcategory';
                                $scope.stateObj = { department: hyphenate(department), subdepartment: hyphenate(subdepartment), category: hyphenate(category), subcategory: hyphenate(subcategory) };
                            } else if (brandcategory.length === 3) {
                                $scope.url = 'shop.browse.department.subdepartment.category';
                                $scope.stateObj = { department: hyphenate(department), subdepartment: hyphenate(subdepartment), category: hyphenate(category) };
                            } else if (brandcategory.length === 2) {
                                $scope.url = 'shop.browse.department.subdepartment';
                                $scope.stateObj = { department: hyphenate(department), subdepartment: hyphenate(subdepartment) };
                            } else if (brandcategory.length === 1) {
                                $scope.url = 'shop.browse.department';
                                $scope.stateObj = { department: hyphenate(department) };
                            }
                        } else {
                            $scope.url = 'shop.search';
                            $scope.stateObj = { searchTerm: $scope.hyphenate($scope.productParent.BrandName) };
                        }
                    }

                    $scope.handleViewAllBrandClick = (brandName) => {
                        atm.push({
                            linkName: `web:pdp:view all ${brandName.toLowerCase()} products`,
                            linkType: 'pdp view all brand products'
                        }, pdpLinkClickMapper);
                    };

                    $scope.toggleImageZoomPopup = () => {
                        const isImageZoom = true;

                        modalInstance = $uibModal.open({
                            animation: true,
                            templateUrl: 'image-zoom',
                            size: 'lg',
                            scope: $scope,
                            windowClass: 'modal--image-zoom'
                        });
                        $scope.initCarousel(isImageZoom);
                    };

                    $scope.getBadges = function () {
                        const badges = [];
                        const product = $scope.product;

                        if (product) {
                            for (let i = 0; i < 3 && i < product.Tags.length; i++) {
                                const tag = product.Tags[i];
                                const isAppyDealsTag = isAppyDealsBadge(tag);
                                // don't include Appy Deals tag if not allow to show
                                if (isAppyDealsTag && !$scope.ctrl.showAppyDeals) {
                                    continue;
                                }
                                badges.push(tag);
                            }
                        }

                        return badges;
                    };
                    $scope.setStoreFromGoogleshopping = (regionId) => {
                        $scope.storePicker.setPickupByStoreNo(regionId).then((response) => {
                            if (!response.IsSystemAddress) {
                                $scope.goToProductPage();
                                location.reload();
                            } else {
                                $scope.goToProductPage();
                            }
                        });
                    };
                    $scope.getGSDetails = () => {
                        $scope.regionId = parseInt($location.search().region_id);
                        if ($scope.regionId) {
                            if ($scope.storePicker.fulfilmentInfo.IsSystemAddress) {
                                $scope.setStoreFromGoogleshopping($scope.regionId);
                                return;
                            }
                            $scope.defaultProductCode = parseInt($scope.productId) || $scope.productDefault.Stockcode;
                            $scope.product = _.find($scope.productCollection.Products, { Stockcode: parseInt($scope.productId) });
                            atm.push($scope.product, atmProductCrossSellMapper);
                            if (parseInt($location.search().region_id) !== parseInt($scope.storePicker.store.FulfilmentStoreID)) {
                                detailProductService.getGSProductDetail($scope.productId, $scope.regionId)
                                    .then(function (product) {
                                        if ((product && product.StoreName && !product.HasEqualPrice) || !$scope.product.IsAvailable) {
                                            $scope.selectedGSStore = product.StoreName;
                                            $scope.showGoogleShopping = true;
                                            $scope.showGoogleShoppingDetails = product;
                                        } else {
                                            $scope.goToProductPage();
                                        }
                                    });
                            } else {
                                $scope.goToProductPage();
                            }
                        }
                    };

                    function setCrossSellType(msg, state) {
                        // Appy Deal specific
                        if (state.source && state.source === APPY_DEALS_PAGE_SOURCE_ID) {
                            const appyDealsEventData = inMemoryStorage.getItem(APPY_DEALS_EVENT_DATA);
                            if (appyDealsEventData) {
                                msg.crossSellType = appyDealsEventData.crossSellType;
                            }

                            return;
                        }

                        if (!msg.crossSellType || msg.crossSellType.length < 8 || !state.source) {
                            return;
                        }

                        if (/.*Breinify.*/.test(state.source)) {
                            msg.crossSellType = `${msg.crossSellType.substr(0, 8)}breinify-${msg.crossSellType.substr(8)}`;
                        } else if (/.*RichRelevance.*/.test(state.source)) {
                            msg.crossSellType = `${msg.crossSellType.substr(0, 8)}rich relevance-${msg.crossSellType.substr(8)}`;
                        }
                    }

                    function setAppyDeals() {
                        // remove 'AppyDealsEventData' if user is not come from Appy Deals product list page
                        if ($stateParams.source && $stateParams.source !== APPY_DEALS_PAGE_SOURCE_ID) {
                            const appyDealsEventData = inMemoryStorage.getItem(APPY_DEALS_EVENT_DATA);
                            if (appyDealsEventData) {
                                inMemoryStorage.removeItem(APPY_DEALS_EVENT_DATA);
                            }
                        }

                        if (!$scope.product) {
                            return;
                        }

                        settingsService
                            .getSettingValue('Loyalty', 'EnableAppBasedOffers')
                            .then((val) => {
                                isEnableAppBasedOffers = !!val;

                                if (isEnableAppBasedOffers && appyDealsCheck($scope.product) && !$scope.restrictedCategory) {
                                    $scope.ctrl.showAppyDeals = true;
                                }
                            });
                    }

                    function _init() {
                        $scope.loading = true;
                        $scope.backOrderCollectionTime = collectionTimeService.calculateBackorderPickupDate();
                        const productDetail = detailProductService.cache;

                        $scope.productDefault = productDetail.defaultProduct;
                        $scope.productCollection = productDetail;

                        //We have click on a product in a product group
                        if ($stateParams.overwriteDefaultProduct) {
                            $scope.product = _.find($scope.productCollection.Products, { Stockcode: $stateParams.overwriteDefaultProduct });

                        } else {
                            $scope.product = productDetail.defaultProduct;
                        }
                        $scope.productParent = productDetail.parentProduct;
                        $scope.deliveryMessage = productDetail.DeliveryMessage;

                        checkAvailability();

                        //Check if there is an item in the trolley
                        const itemInTrolley = _.find($scope.productCollection.Products, { IsInTrolley: true });
                        const isItemInCollectionInTrolley = !_.isUndefined(itemInTrolley);
                        $scope.productCollection.IsInTrolley = isItemInCollectionInTrolley;
                        if (itemInTrolley) {
                            $scope.productCollection.QuantityInTrolley = itemInTrolley ? itemInTrolley.QuantityInTrolley : 0;
                        }

                        transformAdditionalDetails();
                        cleanAdditionalDetailsForDisplay();

                        $scope.restrictedCategory = false;
                        checkRestrictedCategory();

                        $scope.preOrderMessage = productDetail.PreOrderMessage || '';
                        const formattedDate = formatDate($scope.productDetails.preordermarketreleasedate);
                        if (formattedDate == null || !$scope.product.IsPreOrderEligible) $scope.preOrderMessage = null;
                        else $scope.preOrderMessage = $scope.preOrderMessage.replace('{PreOrderMarketReleaseDate}', formattedDate);

                        $scope.savingsAmount = getSavingsAmount();
                        $scope.showSavingsBadge = showSavingsBadge();
                        $scope.showSuperSaversBadge = showSuperSaversBadge();
                        $scope.ctrl.showPercentageOffBadge = $scope.badgeService.showPercentageOffBadge($scope.product);

                        if ($scope.productParent.ProductData.brandcategory) {
                            brandcategory = $scope.productParent.ProductData.brandcategory.split(' / ');
                            department = brandcategory[0];
                            subdepartment = brandcategory[1];
                            category = brandcategory[2];
                            subcategory = brandcategory[3];
                            $scope.department = department;
                        }

                        if ($scope.productParent.ProductData.legacydepartment) {
                            $state.params.category = ($scope.productParent.ProductData.legacydepartment).toLowerCase();
                        }
                        $scope.product.eventId = productDetail.eventId;

                        $scope.isBeingAddedToTrolley = !$scope.product.IsInTrolley;

                        // prodViewEvent tracking
                        const atmData = { product: $scope.product, crossSellType: $stateParams.crossSellType, isSponsored: $stateParams.isSponsored, promoteIQCampaignId: $stateParams.promoteIQCampaignId };

                        if (inMemoryStorage.getItem('prodViewEventData')) {
                            atmData.eventData = inMemoryStorage.getItem('prodViewEventData');
                            inMemoryStorage.removeItem('prodViewEventData');
                        }
                        $scope.product.IsSponsored = $stateParams.isSponsored;
                        $scope.product.CampaignId = $stateParams.promoteIQCampaignId;

                        setCrossSellType(atmData, $stateParams);

                        atm.push(atmData, atmProductViewMapper);

                        $scope.getGSDetails();

                        // set apply deals scope logic
                        setAppyDeals();

                        if ($location.search().pack_type) {
                            $scope.product = _.find($scope.productCollection.Products, { Stockcode: parseInt($scope.productId) });
                            $scope.defaultProductCode = parseInt($scope.productId) || $scope.productDefault.Stockcode;
                        }

                        if (navigator.userAgent.match(/iPad/i) === null) {
                            $scope.videoUrl = $sce.trustAsResourceUrl($scope.productDetails.videourl);
                        }

                        $scope.initCarousel();
                        getProductBackOrderStockOnHand();
                        viewRelatedProducts();

                        //Analytics for Products in same offer view
                        analyticsRelatedProductView();
                    }

                    $scope.$on('showGoogleShopping:update', (e, update) => {
                        $scope.showGoogleShopping = update;
                        if (!update) return;
                        detailProductService.getProductDetail($scope.productId, null, null, null, null)
                            .then((response) => {
                                detailProductService.cache = response;
                                $scope.showGoogleShopping = false;
                                $scope.showGoogleShoppingDetails = null;
                                _init();
                            });
                    });

                    $scope.$on('$destroy', function() {
                        // ensure clear 'AppyDealsEventData' on unmount
                        const appyDealsEventData = inMemoryStorage.getItem(APPY_DEALS_EVENT_DATA);
                        if (appyDealsEventData) {
                            inMemoryStorage.removeItem(APPY_DEALS_EVENT_DATA);
                        }
                    });

                    _init();
                }
            };
        }
    };
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/cards/detail/product/detail-product-page-directive.js
 **/